import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { DateTimeUtils } from "@stellar/utils";
import { sortMembersByNameOrEmail } from "@utils/member-utils";
import { getSphereViewerUrl, getWebEditorUrl } from "@utils/project-utils";
import { SnapshotEvents } from "@utils/track-event/track-event-list";
/** Gets the URL to open the snapshot for the provided target. */
export function getOpenSnapshotHref({
  openTarget,
  snapshotId
}) {
  return openTarget === ProjectLaunchTarget.sphereViewer ? getSphereViewerUrl({
    projectId: snapshotId
  }).href : getWebEditorUrl(snapshotId, "player").href;
}
/**
 * Tracks whenever a user wants to open a snapshot in the Sphere Viewer or WebEditor.
 * This function does not open the snapshot, it only tracks the event.
 */
export async function trackOpenSnapshot({
  openFrom,
  numberOfMembers,
  openTarget = ProjectLaunchTarget.sphereViewer,
  clickType,
  trackAsyncEvent,
  createdAt,
  accessLevel
}) {
  const eventProps = {
    openFrom,
    creationAge: DateTimeUtils.getAge(createdAt)
  };
  if (numberOfMembers) {
    eventProps.numberOfMembers = numberOfMembers;
  }
  if (openTarget === ProjectLaunchTarget.sphereViewer) {
    eventProps.openTarget = ProjectLaunchTarget.sphereViewer;
  } else {
    eventProps.openTarget = ProjectLaunchTarget.webEditor;
  }
  if (clickType) {
    eventProps.clickType = clickType;
  }
  if (accessLevel) {
    eventProps.accessLevel = accessLevel;
  }
  await trackAsyncEvent({
    name: SnapshotEvents.openSnapshot,
    props: eventProps
  });
}

/**
 * Sort snapshot members, by name for team first, then by name for members and by email if name isn't available
 * @param members - List of snapshot members
 * @returns Sorted members
 */
export function sortSnapshotMembers(members) {
  return sortMembersByNameOrEmail(members);
}